import React, { useState, useEffect } from "react";
import "../css/layout.css";
import "../css/homepage.css";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Swal from "sweetalert2";
import "../css/Loader.css";
// import findGif from "../css/loading.gif";
import findGif from "../css/loader.gif";
import { apiRequest } from "../store/allApi";

const Withdrawopt = ({ walletUpdate }) => {
  // +++++++++++++++++++++++++++++
  const history = useHistory();

  const udata = JSON.parse(localStorage.getItem("udata"));
  const [Id, setId] = useState(null);
  const [user, setUser] = useState();
  const [holder_name, setHolder_name] = useState();
  const [bank_name, setBank_name] = useState();
  const [account_number, setAccount_number] = useState();
  const [confirm_account_number, setConfirm_account_number] = useState();
  const [ifsc_code, setIfsc_code] = useState();
  const [upi_id, setUpi_id] = useState();
  const [confirm_upi_id, setConfirm_upi_id] = useState();
  const [next, setNext] = useState(false);
  const [withdraw_Qr, setwithdraw_Qr] = useState(null);
  const [withdrawAmount, setWithdrawAmount] = useState();

  const [submitBtn, setSubmitBtn] = useState(true);
  const [withdrawal, setWithdrawal] = useState(true);
  const [Upiwithdrawal, setUpiWithdrawal] = useState(true);
  const [Bankwithdrawal, setBankWithdrawal] = useState(true);
  const [Qrwithdrawal, setQrWithdrawal] = useState(true);
  const [withdrawalLimitMinBank, setWithdrawalBankMin] = useState("");
  const [withdrawalLimitMaxBank, setWithdrawalBankMax] = useState("");
  const [withdrawalLimitMinQr, setWithdrawalQrMin] = useState("");
  const [withdrawalLimitMaxQr, setWithdrawalQrMax] = useState("");

  const [minLimit, setMinLimit] = useState(null);
  const [maxLimit, setMaxLimit] = useState(null);
  const [isLoading, setIsloading] = useState(false);

  const [type, setType] = useState(undefined);
  const [mount, setMount] = useState(false);
  const [amount, setAmount] = useState();

  useEffect(() => {
    const addsetting = localStorage.getItem("sitSetting");
    const addCaseSetting = JSON.parse(addsetting);
    setWithdrawal(addCaseSetting.isWithdrawal);
    setUpiWithdrawal(addCaseSetting.isUpiWithdrawal);
    setBankWithdrawal(addCaseSetting.isBankWithdrawal);
    setQrWithdrawal(addCaseSetting.isQrWithdrawal);
    setMinLimit(addCaseSetting.withdrawalLimitMin);
    setMaxLimit(addCaseSetting.withdrawalLimitMax);
    setWithdrawalBankMin(addCaseSetting.withdrawalLimitMinBank);
    setWithdrawalBankMax(addCaseSetting.withdrawalLimitMaxBank);
    setWithdrawalQrMin(addCaseSetting.withdrawalLimitMinQr);
    setWithdrawalQrMax(addCaseSetting.withdrawalLimitMaxQr);
  });

  const Me = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest("me", "GET", null, headers);
      setUser(res.data);
      // console.log(res.data, "data");
      setId(res.data._id);
      setHolder_name(res.data.holder_name);
      setBank_name(res.data.bank_name);
      setAccount_number(res.data.account_number);
      setConfirm_account_number(res.data.confirm_account_number);
      setIfsc_code(res.data.ifsc_code);
      setUpi_id(res.data.upi_id);
      setConfirm_upi_id(res.data.upi_id);
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        history.push("/login");
      }
    }
  };

  useEffect(() => {
    Me();
  }, []);

  const handleIfscChange = (e) => {
    const value = e.target.value.toUpperCase(); // Convert to uppercase
    if (value.length <= 11 && /^[A-Z0-9]*$/.test(value)) {
      // Allow only uppercase letters and digits, and limit to 11 characters
      setIfsc_code(value);
    }
  };

  const updateBankDetails = async () => {
    setIsloading(true);

    setMount(true);
    setSubmitBtn(false);

    if (type === "upi") {
      let regex = /^[\w.-]+@[\w.-]+$/.test(upi_id);

      if (regex) {
        if (upi_id === confirm_upi_id) {
          Swal.fire({
            title: `Is your UPI ID correct? ${upi_id}`,
            icon: "success",
            confirmButtonText: "OK",
          });

          const access_token = localStorage.getItem("token");
          const headers = {
            Authorization: `Bearer ${access_token}`,
          };

          setIsloading(true);
          const data = await axios
            .patch(
              "https://bkhub.mrludohub.com/user/withdraw/edit",
              {
                holder_name,
                upi_id,
              },
              { headers },
            )
            .then((res) => {
              setIsloading(false);

              if (res.data.status === true) {
                let calculatedWallet =
                  user.wonAmount -
                  user.loseAmount +
                  user.totalDeposit +
                  user.referral_earning +
                  user.hold_balance +
                  user.totalBonus -
                  (user.totalWithdrawl +
                    user.referral_wallet +
                    user.totalPenalty);

                if (calculatedWallet === user.Wallet_balance) {
                  withReqComes();
                } else {
                  Swal.fire({
                    title: "Missmatch in wallet",
                    icon: "error",
                    confirmButtonText: "OK",
                  });
                }
              } else {
                setMount(false);
                setSubmitBtn(true);
                Swal.fire({
                  title: res.data.msg,
                  icon: "error",
                  confirmButtonText: "OK",
                });
              }
            })
            .catch((e) => {
              console.log(e);
              setMount(false);
              if (e.response.status == 401) {
                localStorage.removeItem("token");
                localStorage.removeItem("token");
                window.location.reload();
                history.push("/login");
              }
            });
        } else {
          Swal.fire({
            title: "UPI IDs do not match",
            text: "Please make sure your UPI IDs match",
            icon: "error",
            confirmButtonText: "OK",
          });
          setSubmitBtn(true);
        }
      } else {
        Swal.fire({
          title: `Invalid UPI ID: ${upi_id}`,
          text: "Please enter a valid UPI ID",
          icon: "error",
          confirmButtonText: "OK",
        });
        setSubmitBtn(true);
      }
    } else if (
      type === "banktransfer" &&
      (!uData.account_number || !uData.ifsc_code)
    ) {
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      setIsloading(true);
      const data = await axios
        .patch(
          "https://bkhub.mrludohub.com/user/withdraw/edit",
          {
            holder_name,
            account_number,
            confirm_account_number,
            ifsc_code,
          },
          { headers },
        )
        .then((res) => {
          setIsloading(false);

          if (res.data.status === true) {
            let calculatedWallet =
              user.wonAmount -
              user.loseAmount +
              user.totalDeposit +
              user.referral_earning +
              user.hold_balance +
              user.totalBonus -
              (user.totalWithdrawl + user.referral_wallet + user.totalPenalty);

            if (calculatedWallet === user.Wallet_balance) {
              withReqComes();
            } else {
              Swal.fire({
                title: "Missmatch in wallet",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          } else {
            setMount(false);
            setSubmitBtn(true);
            Swal.fire({
              title: res.data.msg,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          setMount(false);
          if (e.response.status == 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("token");
            window.location.reload();
            history.push("/login");
          }
        });
    } else if (type === "banktransfer" && uData.account_number) {
      withReqComes();
      setIsloading(false);
    } else if (type === "qrcode") {
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      setIsloading(true);
      const data = await axios
        .patch(
          "https://bkhub.mrludohub.com/user/withdraw/edit",
          {
            holder_name,
          },
          { headers },
        )
        .then((res) => {
          setIsloading(false);

          if (res.data.status === true) {
            let calculatedWallet =
              user.wonAmount -
              user.loseAmount +
              user.totalDeposit +
              user.referral_earning +
              user.hold_balance +
              user.totalBonus -
              (user.totalWithdrawl + user.referral_wallet + user.totalPenalty);

            if (calculatedWallet === user.Wallet_balance) {
              withReqComes();
            } else {
              Swal.fire({
                title: "Missmatch in wallet",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          } else {
            setMount(false);
            setSubmitBtn(true);
            Swal.fire({
              title: res.data.msg,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          setMount(false);
          if (e.response.status == 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("token");
            window.location.reload();
            history.push("/login");
          }
        });
    } else {
      setMount(false);
      setSubmitBtn(true);
    }
  };

  const withReqComes = async () => {
    console.log(withdrawAmount);
    try {
      setMount(true);

      let payment_gateway = type === "upi" ? "razorpay" : "decentro";

      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      if (amount < minLimit || amount > maxLimit) {
        Swal.fire({
          title: "Invalid amount",
          text: "Please enter an amount within the allowed limits.",
          icon: "error",
          confirmButtonText: "OK",
        });
        setMount(false);
      } else if (type === "qrcode" && !withdraw_Qr) {
        Swal.fire({
          title: "QR Code Required",
          text: "Please provide a valid QR Code for withdrawal.",
          icon: "error",
          confirmButtonText: "OK",
        });
        setMount(false);
      } else if (type === "banktransfer" && (!ifsc_code || !account_number)) {
        Swal.fire({
          title: "All Fields Are Required",
          icon: "error",
          confirmButtonText: "OK",
        });
        setMount(false);
      } else {
        const formData = new FormData();

        formData.append("amount", withdrawAmount);
        formData.append("type", type);
        formData.append("payment_gateway", payment_gateway);
        formData.append("withdraw_Qr", withdraw_Qr);
        formData.append("emergencyWithdraw", "false");

        try {
          const res = await apiRequest(
            "withdraw/request",
            "POST",
            formData,
            headers,
          );

          if (res.data.success) {
            setMount(false);
            Swal.fire({
              title: res?.data?.msg,
              icon: "success",
              confirmButtonText: "OK",
            });
            history.push("/");
          } else {
            Swal.fire({
              title: res.data.msg,
              icon: "error",
              confirmButtonText: "OK",
            });
          }

          setMount(false);
        } catch (e) {
          console.log(e);
          setMount(false);
        }
      }
    } catch (error) {
      console.log(error);
      setMount(false);
    }
  };

  const [settingData, setSettingData] = useState("");
  const [uData, setUserData] = useState("");

  useEffect(() => {
    const storedData = localStorage.getItem("sitSetting");
    const UserData = localStorage.getItem("udata");
    if (storedData) {
      setSettingData(JSON.parse(storedData));
    }
    if (UserData) {
      setUserData(JSON.parse(UserData));
    }
  }, []);

  const handlePayment = () => {
    if (withdrawAmount) {
      if (withdrawAmount < minLimit || withdrawAmount > maxLimit) {
        Swal.fire({
          title: "Invalid amount",
          text: ` Minimum withdrawal amount ${minLimit} Maximum withdrawal amount ${maxLimit}`,
          icon: "error",
          confirmButtonText: "OK",
        });
      } else {
        setNext(2);
      }
    } else {
      Swal.fire({
        title: "Please Fill Amount",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <>
      <div
        className="leftContainer mb_space"
        style={{ minHeight: "100vh", height: "100%" }}
      >
        <div className="container px-3 pt-3" style={{ height: "10px" }}>
          <div className="row">
            <div className="col mx-auto">
              <div className="mt-3">
                <div className="gameCard">
                  <div className="alrt_msg_div">
                    <h5 className="">
                      दुबारा बैंक अकाउंट चेंज करने के लिए Admin से संपर्क करें |
                    </h5>
                  </div>
                </div>
                {user &&
                  user?.verified === "verified" &&
                  user?.Email !== null && (
                    <div className=" ">
                      <h4
                        className="pt-1 profile_headings1 "
                        style={{ color: "black !important" }}
                      >
                        {type == undefined
                          ? "Choose withdrawal option"
                          : "Withdraw through"}
                      </h4>
                      {Boolean(!next) && (
                        <>
                          <div className="add_amount_main_box_inner mt-4">
                            <label className="label">Withdraw Amount</label>
                            <div className="enter_amount_input_box">
                              <span className="img-size">
                                <img
                                  src="/images/rupee.png"
                                  alt=""
                                  className="snip-img w-21"
                                />
                              </span>
                              <input
                                className="enter_amount_input"
                                type="tel"
                                id="amountInput"
                                placeholder="Enter Amount To Withdraw"
                                value={withdrawAmount}
                                onChange={(e) =>
                                  setWithdrawAmount(e.target.value)
                                }
                              />
                            </div>

                            <div className="text-center mt-3">
                              <button
                                type="button"
                                className="btn2 btn-success"
                                onClick={() => {
                                  const val = parseInt(withdrawAmount);

                                  if (!val || val <= 0) {
                                    Swal.fire({
                                      icon: "warning",
                                      title: "गलत राशि",
                                      text: "कृपया मान्य राशि दर्ज करें",
                                    });
                                    return;
                                  }

                                  if (val % 100 !== 0) {
                                    Swal.fire({
                                      icon: "error",
                                      title: "गलत राशि",
                                      text: "👉 कृपया withdrawal 1000, 1200, 1400, 1600, 1800, 2000, --- के क्रम में ही मिलेगा🙏 धन्यवाद 🙏",
                                    });
                                    return;
                                  }

                                  if (val > 100000) {
                                    Swal.fire({
                                      icon: "warning",
                                      title: "सीमा से अधिक",
                                      text: "अधिकतम निकासी राशि 100000 है",
                                    });
                                    return;
                                  }

                                  // ✅ सब ठीक है तो payment process चलेगा
                                  handlePayment();
                                }}
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        </>
                      )}

                      {next === 2 ? (
                        <div>
                          <>
                            {settingData.isBankWithdrawal === true ||
                            settingData.isUpiWithdrawal === true ? (
                              <div>
                                {/* upi id */}
                                {Upiwithdrawal === true &&
                                withdrawAmount >= withdrawalLimitMinBank &&
                                withdrawAmount <= withdrawalLimitMaxBank ? (
                                  <div
                                    onClick={() => {
                                      setType("upi");
                                      setNext(3);
                                    }}
                                    className="add-fund-box"
                                  >
                                    <div className="withdrawbox">
                                      <div className="withdrawbox_icon">
                                        <img
                                          width="45px"
                                          src={
                                            process.env.PUBLIC_URL + "/UPI.png"
                                          }
                                          style={{ filter: "brightness(100)" }}
                                          alt=""
                                        />
                                      </div>
                                      <div className="withdrawbox_right">
                                        <div className="text-left">
                                          <h3>Withdraw through UPI</h3>
                                          <ul>
                                            <li>
                                              Minimum withdrawal amount{" "}
                                              {minLimit}
                                            </li>
                                            <li>
                                              Maximum withdrawal amount{" "}
                                              {maxLimit}
                                            </li>
                                            <li>
                                              Instant withdrawal within 30sec.
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="jss31"></div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {/* bank account number */}
                                {Bankwithdrawal === true &&
                                withdrawAmount >= withdrawalLimitMinBank &&
                                withdrawAmount <= withdrawalLimitMaxBank ? (
                                  <div
                                    onClick={() => {
                                      setType("banktransfer");
                                      setNext(3);
                                    }}
                                    className="add-fund-box"
                                  >
                                    <div className="withdrawbox">
                                      <div className="withdrawbox_icon">
                                        <img
                                          width="45px"
                                          src="../images/icons/bank.gif"
                                          alt=""
                                        />
                                      </div>
                                      <div className="withdrawbox_right">
                                        <div className="text-left">
                                          <h3>Bank Transfer</h3>
                                          <ul>
                                            <li>
                                              Minimum withdrawal amount{" "}
                                              {minLimit}
                                            </li>
                                            <li>
                                              Maximum withdrawal amount{" "}
                                              {maxLimit}
                                            </li>
                                            <li>
                                              Instant withdrawal within 30sec.
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="jss31"></div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {/* Qr withdraw */}
                                {Qrwithdrawal === true &&
                                withdrawAmount >= withdrawalLimitMinQr &&
                                withdrawAmount <= withdrawalLimitMaxQr ? (
                                  <div
                                    onClick={() => {
                                      setType("qrcode");
                                      setNext(3);
                                    }}
                                    className="add-fund-box"
                                  >
                                    <div className="withdrawbox">
                                      <div className="withdrawbox_icon">
                                        <img
                                          width="45px"
                                          src="../images/icons/bank.gif"
                                          alt=""
                                        />
                                      </div>
                                      <div className="withdrawbox_right">
                                        <div className="text-left">
                                          <h3>QR CODE</h3>
                                          <ul>
                                            <li>
                                              Minimum withdrawal amount{" "}
                                              {minLimit}
                                            </li>
                                            <li>
                                              Maximum withdrawal amount{" "}
                                              {maxLimit}
                                            </li>
                                            <li>
                                              Instant withdrawal within 30sec.
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="jss31"></div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : (
                              <div className="gameCard pt-2">
                                <div className="alrt_msg_div">
                                  <h5 className="">
                                    {settingData?.withdrawalmsg}
                                  </h5>
                                </div>
                              </div>
                            )}
                          </>
                        </div>
                      ) : (
                        ""
                      )}

                      {Boolean(next) && (
                        <div className="mb-5">
                          <div className="text-left w-100">
                            {/* upi id */}
                            {Boolean(Upiwithdrawal) &&
                              Boolean(type === "upi") && (
                                <div className="add-fund-box">
                                  <div className="withdrawbox">
                                    <div className="withdrawbox_icon">
                                      <img
                                        width="45px"
                                        src={
                                          process.env.PUBLIC_URL + "/UPI.png"
                                        }
                                        style={{ filter: "brightness(100)" }}
                                        alt=""
                                      />
                                    </div>
                                    <div className="withdrawbox_right">
                                      <div className="text-left">
                                        <h3>Withdraw through UPI</h3>

                                        <ul>
                                          <li>
                                            Minimum withdrawal amount {minLimit}
                                          </li>
                                          <li>
                                            Instant withdrawal within 30sec.
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="jss31"></div>
                                    </div>
                                    <button
                                      onClick={() => {
                                        setNext(false);
                                      }}
                                      className="btn btn-info text-white font-weight-bold ml-auto mr-3 "
                                      style={{ fontSize: "0.5rem" }}
                                    >
                                      Edit
                                    </button>
                                  </div>
                                </div>
                              )}
                            {/* bank account number */}
                            {Boolean(Bankwithdrawal) &&
                              Boolean(type === "banktransfer") && (
                                <div className="add-fund-box">
                                  <div className="withdrawbox">
                                    <div className="withdrawbox_icon">
                                      <img
                                        width="45px"
                                        src="../images/icons/bank.gif"
                                        alt=""
                                      />
                                    </div>
                                    <div className="withdrawbox_right">
                                      <div className="text-left">
                                        <h3>Bank Transfer</h3>

                                        <ul>
                                          <li>
                                            Minimum withdrawal amount {minLimit}
                                          </li>
                                          <li>
                                            Instant withdrawal within 30sec.
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="jss31"></div>
                                    </div>
                                    <button
                                      onClick={() => {
                                        setType(undefined);
                                        setNext(false);
                                        console.log(type);
                                      }}
                                      className="btn btn-info text-white font-weight-bold ml-auto mr-3"
                                      style={{ fontSize: "0.5rem" }}
                                    >
                                      Edit
                                    </button>
                                  </div>
                                </div>
                              )}

                            {/* Qr withdraw */}
                            {Boolean(Qrwithdrawal) &&
                              Boolean(type === "qrcode") && (
                                <div className="add-fund-box">
                                  <div className="withdrawbox">
                                    <div className="withdrawbox_icon">
                                      <img
                                        width="45px"
                                        src="../images/icons/bank.gif"
                                        alt=""
                                      />
                                    </div>
                                    <div className="withdrawbox_right">
                                      <div className="text-left">
                                        <h3>QR Transfer</h3>

                                        <ul>
                                          <li>
                                            Minimum withdrawal amount {minLimit}
                                          </li>
                                          <li>
                                            Instant withdrawal within 30sec.
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="jss31"></div>
                                    </div>
                                    <button
                                      onClick={() => {
                                        setType(undefined);
                                        setNext(false);
                                        console.log(type);
                                      }}
                                      className="btn btn-info text-white font-weight-bold ml-auto mr-3"
                                      style={{ fontSize: "0.5rem" }}
                                    >
                                      Edit
                                    </button>
                                  </div>
                                </div>
                              )}

                            <div className="mt-4">
                              {/* upi id */}
                              {Boolean(Upiwithdrawal) && type === "upi" && (
                                <>
                                  <label className="mr-5 commaon_label text-white">
                                    <i className="far fa-user mr-2"></i>
                                    Account holder name (खाता धारक का नाम) :
                                  </label>
                                  <div className="col-12 mb-3 p-0">
                                    <input
                                      type="text"
                                      className="form-control commaon_input_box"
                                      id="account_no"
                                      placeholder="Enter Account Name"
                                      name="ifsc"
                                      value={holder_name}
                                      onChange={(e) =>
                                        setHolder_name(e.target.value)
                                      }
                                      required
                                    />
                                  </div>

                                  <label className="mr-5 commaon_label text-white">
                                    <i className="far fa-bank mr-2"></i>UPI ID
                                    (UPI आईडी) || EX. (9999999999@xyz)
                                  </label>
                                  <div className="col-12 mb-3 p-0">
                                    <input
                                      type="text"
                                      className="form-control commaon_input_box"
                                      id="account_no"
                                      placeholder="Enter Your UPI ID Ex.(9999999999@xyz)"
                                      name="ifsc"
                                      value={upi_id}
                                      onChange={(e) =>
                                        setUpi_id(e.target.value)
                                      }
                                      disabled={!!udata?.upi_id}
                                    />
                                  </div>

                                  <label className="mr-5 commaon_label text-white">
                                    <i className="far fa-bank mr-2"></i> Confirm
                                    UPI ID: (कन्फर्म UPI आईडी) || EX.
                                    (9999999999@xyz)
                                  </label>
                                  <div className="col-12 mb-3 p-0">
                                    <input
                                      type="text"
                                      className="form-control commaon_input_box"
                                      id="account_no"
                                      placeholder="Re Enter Your UPI ID Ex.(9999999999@xyz)"
                                      name="ifsc"
                                      value={
                                        udata?.upi_id
                                          ? udata?.upi_id
                                          : confirm_upi_id
                                      }
                                      onChange={(e) =>
                                        setConfirm_upi_id(e.target.value)
                                      }
                                      disabled={!!udata?.upi_id} // agar pehle se hai to ye bhi disable
                                    />
                                  </div>
                                  <small className="small_para text-white">
                                    कृपया सही UPI आईडी Ex.(9999999999@xyz) दर्ज
                                    करें।*
                                  </small>
                                </>
                              )}

                              {/* bank account number */}
                              {Boolean(Bankwithdrawal) &&
                                type === "banktransfer" && (
                                  <>
                                    <label className="mr-5 commaon_label text-white">
                                      <i className="far fa-user mr-2"></i>
                                      Account holder name (खाता धारक का नाम)
                                    </label>
                                    <div className="col-12 mb-3 p-0">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="account_no"
                                        placeholder="Enter Account Name"
                                        name="ifsc"
                                        value={holder_name}
                                        onChange={(e) =>
                                          setHolder_name(e.target.value)
                                        }
                                        required
                                      />
                                    </div>

                                    <label className="mr-5 commaon_label text-white">
                                      <i className="far fa-bank mr-2"></i>
                                      Account number (खाता संख्या):
                                    </label>
                                    <div className="col-12 mb-3 p-0">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="account_no"
                                        placeholder="Enter your bank account number"
                                        name="upi"
                                        value={account_number}
                                        onChange={(e) =>
                                          setAccount_number(e.target.value)
                                        }
                                        disabled={
                                          uData?.account_number !== null &&
                                          uData?.account_number !== ""
                                        }
                                      />

                                      <label className="mr-5 commaon_label text-white">
                                        <i className="far fa-bank mr-2"></i>{" "}
                                        Confirm Account number (कन्फर्म खाता
                                        संख्या) :
                                      </label>
                                      <div className="col-12 mb-3 p-0">
                                        <input
                                          type="text"
                                          className="form-control commaon_input_box"
                                          id="account_no"
                                          placeholder="Re Enter Your Bank Account Number"
                                          name="ifsc"
                                          value={
                                            uData?.account_number
                                              ? account_number
                                              : confirm_account_number
                                          }
                                          onChange={(e) =>
                                            setConfirm_account_number(
                                              e.target.value,
                                            )
                                          }
                                          disabled={
                                            uData?.account_number !== null &&
                                            uData?.account_number !== ""
                                          }
                                        />
                                      </div>
                                    </div>

                                    <label className="mr-5 commaon_label text-white">
                                      <i className="far fa-bank mr-2"></i>
                                      IFSC code (IFSC कोड ) :
                                    </label>
                                    <div className="col-12 mb-3 p-0">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="account_no"
                                        placeholder="Enter IFSC code"
                                        name="ifsc"
                                        value={ifsc_code}
                                        onChange={handleIfscChange}
                                        disabled={
                                          uData?.ifsc_code !== null &&
                                          uData?.ifsc_code !== ""
                                        }
                                      />
                                    </div>
                                  </>
                                )}

                              {/* Qr withdraw */}
                              {Boolean(Qrwithdrawal) && type === "qrcode" && (
                                <>
                                  <label className="mr-5 commaon_label text-white">
                                    <i className="far fa-user mr-2"></i>
                                    Account holder name (खाता धारक का नाम)
                                  </label>
                                  <div className="col-12 mb-3 p-0">
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="account_no"
                                      placeholder="Enter Account Name"
                                      name="ifsc"
                                      value={holder_name}
                                      onChange={(e) =>
                                        setHolder_name(e.target.value)
                                      }
                                      required
                                    />
                                  </div>
                                  <label className="mr-5 commaon_label text-white">
                                    <i className="far fa-user mr-2"></i>
                                    Upload Your Qr Code (अपना क्यूआर कोड डाले |)
                                  </label>
                                  <div className="col-12 mb-3 p-0">
                                    <Row
                                      style={{
                                        marginRight: "4.25rem",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <Col sm={1}>
                                        <input
                                          type="file"
                                          accept="image/*"
                                          name="rkludoPopular"
                                          onChange={(e) =>
                                            setwithdraw_Qr(e.target.files[0])
                                          }
                                          style={{ width: "200px" }}
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                </>
                              )}
                            </div>

                            {next === 3 ? (
                              <>
                                <div>
                                  <label className="mr-5 commaon_label text-white">
                                    <span>₹</span>
                                    Coin
                                  </label>
                                </div>
                                <div className="field col-12 p-0 mt-1 mb-3">
                                  <input
                                    type="phone"
                                    className="form-control  search-slt commaon_input_box"
                                    name="amount"
                                    placeholder="Enter coin"
                                    value={withdrawAmount}
                                    // onChange={(e) => setAmount(withdrawAmount)}
                                  />
                                </div>
                                <div
                                  className="col-12 p-0 mt-2 pt-3"
                                  style={{ marginBottom: "20px" }}
                                >
                                  {isLoading ? (
                                    <div className="pl-2 text-center">
                                      <img
                                        src={findGif}
                                        style={{
                                          width: "80px",
                                          height: "80px",
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <button
                                      type="button"
                                      className="withdraw_request"
                                      onClick={() => updateBankDetails()}
                                    >
                                      WITHDRWAL SUBMIT
                                    </button>
                                  )}

                                  {/* {Boolean(submitBtn) ? "" : "Reload Page"}s */}
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                {user && user?.verified === "unverified" && (
                  <Link to="/profile">
                    <div style={{ height: "100px" }} className="kyc_page_cards">
                      <picture className="ml-3">
                        <img
                          src="/images/alert.svg"
                          alt=""
                          width="32px"
                          className=""
                        />
                      </picture>
                      <p className="ml-1  mytext ">
                        Complete KYC to take Withdrawals Click here !
                      </p>
                    </div>
                  </Link>
                )}
                {user && user.verified === "reject" && (
                  <div style={{ height: "100px" }} className="kyc_page_cards">
                    <picture className="ml-3">
                      <img
                        src="/images/alert.svg"
                        alt=""
                        width="32px"
                        className=""
                      />
                    </picture>
                    <p className="ml-1  mytext ">
                      Your kyc was rejected please please try again !
                    </p>
                  </div>
                )}
                {user && user.verified === "pending" && (
                  <div style={{ height: "100px" }} className="kyc_page_cards">
                    <picture className="ml-3">
                      <img
                        src="/images/alert.svg"
                        alt=""
                        width="32px"
                        className=""
                      />
                    </picture>
                    <p className="ml-1  mytext  ">
                      Please wait your kyc under process
                    </p>
                  </div>
                )}
                {user && user?.Email === null && (
                  <Link to="/profile">
                    <div style={{ height: "100px" }} className="kyc_page_cards">
                      <picture className="ml-3">
                        <img
                          src="/images/alert.svg"
                          alt=""
                          width="32px"
                          className=""
                        />
                      </picture>
                      <p className="ml-1  mytext ">
                        Complete Email Verification to take Withdrawals
                      </p>
                    </div>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Withdrawopt;
